
// SVG Icon: close-tool
export default { id: "terriajs-close-tool" };
export const id = "terriajs-close-tool";
export const name = "close-tool";
